import ShipmentDetailsForm from "./ShipmentDetailsForm";

export default ShipmentDetailsForm;
